export default {
    namespaced: true,
    state: {
        messageView: null,
    },
    getters: {
        /**
         * возвращает объект сообщения
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @returns {null}
         */
        getMessageView: (state) => state.messageView,
    },
    mutations: {
        /**
         * мутация, записывает передаваемое сообщение в хранилище, далее это сообщение выводится для пользователя в виде предупреждения/ошибки/успеха
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @param msg - объект сообщения
         * @constructor
         */
        SET_MESSAGE_VIEW(state, msg) {
            switch (msg.type) {
                case "success": {
                    msg.summary = "Сообщение об успехе";
                    break;
                }
                case "warning": {
                    msg.summary = "Предупреждающее сообщение";
                    break;
                }
                case "info": {
                    msg.summary = "Требуется авторизация";
                    break;
                }
                case "error": {
                    msg.summary = "Сообщение об ошибке";
                    break;
                }
            }

            state.messageView = msg;
        },
        /**
         * мутация, очищает сообщение в хранилище
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @constructor
         */
        CLEAR_MESSAGE_VIEW(state) {
            state.messageView = null;
        },
    },
};
